import useSound from 'use-sound'
import { useState } from 'react'

import Box from '@mui/material/Box'

import MusicNote from '@mui/icons-material/MusicNote'
import PauseCircleOutlined from '@mui/icons-material/PauseCircleOutlined'
import PlayCircleOutlined from '@mui/icons-material/PlayCircleOutlined'

import { visuallyHidden } from '@mui/utils'

interface AudioProps {
  active?: boolean
  onClick?: Function
  thumb?: boolean
  url: string
}

export default function Audio({ active, onClick, thumb, url }: AudioProps) {
  const [playing, setPlaying] = useState(false)
  const [play, { pause }] = useSound(url, {
    onend: () => setPlaying(false),
    onpause: () => setPlaying(false),
    onplay: () => setPlaying(true),
  })

  const className = thumb ? 'c-glide__thumbnail' : 'c-slider__preview'
  let altText = null
  let icon = null
  if (thumb) {
    icon = <MusicNote />
  } else if (playing) {
    icon = <PauseCircleOutlined fontSize='large' />
    altText = 'Mettre en pause l’extrait audio'
  } else {
    icon = <PlayCircleOutline fontSize='large' />
    altText = 'Écouter un extrait audio'
  }

  return (
    <button
      className={`${className} ${active ? ' is-active' : ''} audio`}
      onClick={handleClick}
    >
      {icon}
      <Box component='span' sx={visuallyHidden}>
        {altText}
      </Box>
    </button>
  )

  function handleClick() {
    if (thumb) {
      onClick?.()
    } else {
      playing ? pause() : play()
    }
  }
}
